import { random, randomChange } from './helpers.js';

import { TweenMax } from 'gsap';

const THREE = require('three');

function getPoppy(b='') {
    return `./themes/ww1/roll_of_honor/images/final_poppy${b}.png`;
}

const poppieTexture = {
    b0 : new THREE.TextureLoader().load(getPoppy()),
    b10 : new THREE.TextureLoader().load(getPoppy(' - blur1')),
    b20 : new THREE.TextureLoader().load(getPoppy(' - blur2')),
    b30 : new THREE.TextureLoader().load(getPoppy(' - blur3')),
    b40 : new THREE.TextureLoader().load(getPoppy(' - blur4')),
}

const poppieMesh = {
    geometry: new THREE.PlaneGeometry( 10, 10, 1 ),
    material: new THREE.MeshLambertMaterial({
        color: 0xFFFFFF,
        side: THREE.DoubleSide,
        // emissive: 0xFF0000,
        reflectivity: 1,
        map: poppieTexture.b0,
        transparent: true,
        opacity: 1,
    }),
};



export default class Leaf {
    constructor(view, special = false) {

        this.createLeaf();

        this.special = special;
        this.view = view;

        /* Timestamp the leaf */
        this.born = Date.now();


        /* utils */
		this.vw = window.innerWidth;
        this.vh = window.innerHeight;

        this.initTweenObject();
    }

    createLeaf() {
        const geometry = poppieMesh.geometry;
        const texture = poppieTexture.b0;
        const material = poppieMesh.material.clone();

        this.tweening = false;
        this.object = new THREE.Mesh(geometry, material);
        this.object.name = 'leaf';
    }

    initTweenObject() {
        this.tweenedObject = {
            x: this.object.position.x,
            y: this.object.position.y,
            z: this.object.position.z,
            rotX: 0,
            rotY: 0,
            rotZ: 0,
            dir: randomChange(1).or(-1),
        };
    }


    getFieldOfView(objectZ = this.object.position.z) {
        const aspect = this.view.vw / this.view.vh;
        const distance = Math.abs(this.view.camera.position.z - objectZ);
        const vFOV = 45;
        const hFOV = 2 * Math.atan( Math.tan( vFOV / 2 ) * aspect );
        this.field = {
            width: (2 * Math.tan( ( hFOV / 2 ) ) * distance) * 0.85,
            height: (2 * Math.tan( ( vFOV / 2 ) ) * distance) * 0.85,
        };

        return this.field;
    }

    isBelowView() {
        if (!this.field) {this.getFieldOfView()}

        const fieldX = this.field.width / 2;
        const fieldY = this.field.height / 2;

        if (
            this.object.position.x > fieldX ||
            this.object.position.y < -fieldY
        ) {
            return false;
        }

        return true;
    }


    cancelSpecial() {
        this.special = false;
        this.object.material.opacity = 1;
    }


    getBoundingBox() {
        if (!this.field) {this.getFieldOfView()}

        return {
            minX: -(this.field.width/2),
            maxX: this.field.width/2,
            maxY: this.field.height/2,
            minY: -(this.field.height/2),
        };

    }

    startFall() {
        if (this.tweening) {return;}
        this.initTweenObject();
        this.tweening = true;
        this.tweenFloat();
        this.tweenFall();
        this.tweenRotate();
    }

    tweenRotate() {
        const time = random(C.timeF * 10, C.timeT * 10);
        const ease = Linear.easeNone;
        /* current position */
        const cp = this.tweenedObject;

        const power = {
            x: randomChange(1).or(-1) * 10,
            y: randomChange(1).or(-1) * 10,
            z: randomChange(1).or(-1) * 10,
        }

        /* next position */
        const np = {
            rotX: randomChange(cp.rotX).byRange( THREE.Math.degToRad(C.rotXF) * power.x, THREE.Math.degToRad(C.rotXT) * power.x ),
            rotY: randomChange(cp.rotY).byRange( THREE.Math.degToRad(C.rotYF) * power.y, THREE.Math.degToRad(C.rotYT) * power.y ),
            rotZ: randomChange(cp.rotZ).byRange( THREE.Math.degToRad(C.rotZF) * power.z, THREE.Math.degToRad(C.rotZT) * power.z ),
        };

        TweenMax.to(this.tweenedObject, time * 2, {
            rotX: np.rotX,
            rotY: np.rotY,
            rotZ: np.rotZ,
            ease,
        });
    }

    tweenFall() {
        let time = random(C.timeF * 10, C.timeT * 10);

        /* Special poppy falls little longer */
        if (this.special) {
            time = random(C.timeF * 15, C.timeT * 15);
        }


        const ease = Quad.easeOut;

        const bb = this.getBoundingBox();


        const fall = TweenMax.to(this.tweenedObject, time * 2, {
            y: bb.minY * 1.2 * C.gravity,
            ease: Quad.easeOut,
        });

    }

    tweenFloat() {
        const time = random(C.timeF, C.timeT);
        const ease = Quad.easeInOut;
        /* current position */
        const cp = this.tweenedObject;

        /* next position */
        const np = {
            x: randomChange(cp.x).byRange((C.xFrom*cp.dir) * time, (C.xTo*cp.dir) * time),
            z: randomChange(cp.z).by(C.zRandom),
        };


        TweenMax.to(this.tweenedObject, time, {
            x: np.x,
            z: np.z,
            ease,
            onComplete: ()=>{
                this.tweenedObject.dir *= -1;
                this.tweenFloat();
            }
        });
    }

    update() {
        if (!this.tweenedObject || !this.object) {return}

        this.object.position.x = this.tweenedObject.x;
        this.object.position.y = this.tweenedObject.y;
        this.object.position.z = this.tweenedObject.z;
        this.object.rotation.x = this.tweenedObject.rotX;
        this.object.rotation.y = this.tweenedObject.rotY;
        this.object.rotation.z = this.tweenedObject.rotZ;
    }


    refresh() {
        if (!this.object) { return this.kill(); }
        TweenMax.killTweensOf(this.tweenedObject);
        this.tweening = false;
        this.object.position.z = random(-100, 0);
        const field = this.getFieldOfView();
        this.object.position.x = random(-(field.width/2) * 0.2, field.width/2 * 0.2);
        this.object.position.y = field.height / 2;

        /* Keep special poppy in the middle and close to the camera */
        if (this.special) {
            this.object.position.z = 30;
            this.object.position.x = random(-(field.width/2) * 0.2, field.width/2 * 0.2);
            this.object.material.opacity = 1;
        }

        let z = this.object.position.z;

        switch(true) {
            case z < -80:
                this.object.material.map = poppieTexture.b40;
                break;
            case z < -60:
                this.object.material.map = poppieTexture.b30;
                break;
            case z < -40:
                this.object.material.map = poppieTexture.b20;
                break;
            case z < -20:
                this.object.material.map = poppieTexture.b10;
                break;
            default:
                this.object.material.map = poppieTexture.b0;
        }

        this.startFall();
    }

    kill() {
        TweenMax.killTweensOf(this.tweenedObject);
        this.tweening = false;
        this.tweenedObject = undefined;
        this.object.geometry.dispose();
        this.object.material.dispose();
        this.object = undefined;
    }
}



// WEBPACK FOOTER //
// ./roll_of_honor/javascript/Leaf.js